import { __extends } from "tslib";
import * as React from 'react';
import { normalizePoints } from './normalize-points';
import { Tooltip } from '../../../primitives/tooltip/tooltip';
import { namespacedClassnames } from '../../../common/namespace-classes';
export var punchCardRowKey = 'punch-card-row';
var PunchCardRow = /** @class */ (function (_super) {
    __extends(PunchCardRow, _super);
    function PunchCardRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.maxBubbleScale = 6;
        _this.minBubbleScale = 0.5;
        _this.renderBubble = function (normalizedValue, maxValue, index) {
            var props = _this.props;
            var scaleAmount = Math.max((normalizedValue * _this.maxBubbleScale) / maxValue, _this.minBubbleScale);
            var style = {
                transform: "scale(" + scaleAmount + ")"
            };
            var valueBubble = React.createElement("span", { style: style, className: 'value-bubble', "data-scale": scaleAmount });
            var bubbleElem = _this.props.tooltipLabel ? (React.createElement(Tooltip, { body: _this.props.tooltipLabel(props.value.points[index].y), relativeToBody: true }, valueBubble)) : valueBubble;
            return React.createElement("span", { key: props.value.id + index, className: 'value-bubble-container' }, bubbleElem);
        };
        return _this;
    }
    PunchCardRow.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var normalizedPoints = normalizePoints(props.value.points);
        var maxValue = Math.max.apply(Math, normalizedPoints.map(function (p) { return p.y; }));
        var cn = namespacedClassnames(punchCardRowKey);
        return (React.createElement("div", { className: cn },
            props.value.label ? React.createElement("div", { className: 'row-label' }, props.value.label) : null,
            normalizedPoints.map(function (p, i) { return _this.renderBubble(p.y, maxValue, i); })));
    };
    return PunchCardRow;
}(React.PureComponent));
export { PunchCardRow };
//# sourceMappingURL=index.js.map